import axios from "axios";
import toast from "react-hot-toast";

// Sends a kind's whole pinned block in its new order; the server rewrites SortOrder
// from the positions.
export async function reorderPinned(kind: string, ids: string[]): Promise<boolean> {
    try {
        const res = await axios.put("/api/manuals/reorder", { kind, ids });
        if (!res.data.success) {
            toast.error(res.data.message || "Failed to save the new order");
            return false;
        }
        return true;
    } catch (e: any) {
        toast.error(e.response?.data?.message || "Failed to save the new order");
        return false;
    }
}

export async function movePage(pageId: string, folderId: string | null): Promise<boolean> {
    try {
        const res = await axios.put(`/api/manuals/pages/${pageId}/move`, { folderId });
        if (!res.data.success) {
            toast.error(res.data.message || "Failed to move page");
            return false;
        }
        return true;
    } catch (e: any) {
        toast.error(e.response?.data?.message || "Failed to move page");
        return false;
    }
}
